var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.378 1.62167C18.0054 2.2972 19.4966 3.25965 20.7811 4.4618C19.4955 5.66188 18.004 6.62252 16.3767 7.29673C14.5929 8.03581 12.6809 8.41622 10.75 8.41622C8.81911 8.41622 6.90714 8.03581 5.1233 7.29673C3.49604 6.62252 2.00449 5.66188 0.718922 4.4618C2.00341 3.25965 3.49461 2.2972 5.12202 1.62167C6.90595 0.881173 8.81848 0.5 10.75 0.5C12.6815 0.5 14.594 0.881173 16.378 1.62167Z",
    transform: "translate(1 8)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(8.83008 9.5918)",
    fill: "#F7931E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/Eye_Icon.e0138f02bcea7e0b73ce7e9730189a11.svg";
export { ForwardRef as ReactComponent };